import { clsx } from 'clsx';

import cn from './styles.module.sass';

interface IObtainingMethodProps {
    name?: string;
    description?: string;
    onClick?: VoidFunction;
    isActive?: boolean;
}

export const ObtainingMethod = ({
    name,
    description,
    onClick,
    isActive,
}: IObtainingMethodProps) => {
    return (
        <div onClick={onClick} className={clsx(cn.obtainingMethod, isActive && cn.active)}>
            <h3 className={cn.name}>{name}</h3>
            <p className={cn.description}>{description}</p>
        </div>
    );
};
